import { useQuery } from "@tanstack/react-query";
import { getItemsFromCollection } from "directus/src/operations";
import { useCurrencies } from "@/modules/reports/contexts/currency-context";

export const useRevenuePercentage = (jobType, filters = {}) => {
  const { convertToINR } = useCurrencies();

  return useQuery({
    queryKey: ["revenue-percentage", jobType, filters],
    queryFn: async () => {
      const billingFilter = {
        ...filters.billable,
        
        status: { _eq: "collected" },

        ...(filters?.sales_coordinator
          ? {
              job: {
                project: {
                  sales_coordinator: { _eq: filters.sales_coordinator._eq },
                },
              },
            }
          : {}),

        ...(filters?.client
          ? { job: { project: { client: { _eq: filters.client._eq } } } }
          : {}),

        ...(filters?.jobs?.billables?.collected_date
          ? {
              collected_date: filters.jobs.billables.collected_date,
            }
          : {}),

        ...(filters?.jobs?.employees?.employee?.department?._in
          ? {
              job: {
                employees: {
                  employee: {
                    department: {
                      _in: filters.jobs.employees.employee.department._in,
                    },
                  },
                },
              },
            }
          : {}),
      };

      const query = {
        fields: ["amount", "adjusted_amount", "currency", "job.type"],
        filter: billingFilter,
        limit: -1,
      };

      const response = await getItemsFromCollection("billables", query);

      const totalRevenue = response.reduce((total, billable) => {
        const amount = billable.adjusted_amount || billable.amount || 0;
        return total + convertToINR(amount, billable.currency);
      }, 0);

      const typeRevenue = response
        .filter((billable) => billable.job?.type === jobType)
        .reduce((total, billable) => {
          const amount = billable.adjusted_amount || billable.amount || 0;
          return total + convertToINR(amount, billable.currency);
        }, 0);

      const revenuePercentage =
        totalRevenue > 0 ? (typeRevenue / totalRevenue) * 100 : 0;

      return {
        revenuePercentage,
        typeRevenue,
        totalRevenue,
      };
    },
    enabled: !!jobType,
  });
};
